// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
//import { getMessaging, getToken } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCv-_jUIJndNbTMto4BDS6rrY33FGxFGLE",
  authDomain: "vetcall-1627a.firebaseapp.com",
  projectId: "vetcall-1627a",
  storageBucket: "vetcall-1627a.appspot.com",
  messagingSenderId: "664999902618",
  appId: "1:664999902618:web:f3d8cd2e2e731871684e23",
  measurementId: "G-SX8WPG03M5"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
//const messaging = getMessaging(app);
/*
getToken(messaging, {vapidKey: 'BDE5X6X6T0VuqMuTdSSe8HBA8QNa4bbD1ztc-u0-ebSNlCSiDQSZ2l5rTIaeWUDmeoZyGToc4HgSxCCHyZyt-P4'}).then((currentToken) => {
  if (currentToken) {
    console.log("MYTOKEN:"+currentToken);
  } else {
    // Show permission request UI
    console.log('No registration token available. Request permission to generate one.');
    // ...
  }
}).catch((err) => {
  console.log('An error occurred while retrieving token. ', err);
});
*/
/*
export const getTokenForPushNotifications = async () => {
  const messaging = getMessaging();
  const token = await getToken(messaging, {
    vapidKey: 'BDE5X6X6T0VuqMuTdSSe8HBA8QNa4bbD1ztc-u0-ebSNlCSiDQSZ2l5rTIaeWUDmeoZyGToc4HgSxCCHyZyt-P4',
  });
  return token;
}
*/
//export { app, messaging };